import axios from "axios";
import authentication from "@/authentication";

export default {
  baseUrl: process.env.VUE_APP_API_CALAMITY_SERVICE_BASE,
  async closeCalamity(calamityId) {
    await authentication.isAuthenticated();
    const response = await axios.get(
      `${this.baseUrl}/CloseCalamity/${calamityId}`,
      {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      }
    );
    return response.data;
  },
  async editClientEmail(data) {
    await authentication.isAuthenticated();
    const response = await axios.post(`${this.baseUrl}/EditClientEmail`, data, {
      headers: {
        Authorization: `Bearer ${authentication.getToken()}`
      }
    });
    return response.data;
  },
  async getCalamitySummary(idLists) {
    await authentication.isAuthenticated();
    const response = await axios.post(
      `${this.baseUrl}/GetCalamitySummary`,
      idLists,
      {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      }
    );
    return response.data;
  },
  async load() {
    await authentication.isAuthenticated();
    const response = await axios.get(`${this.baseUrl}/Get`, {
      headers: {
        Authorization: `Bearer ${authentication.getToken()}`
      }
    });
    return response.data;
  },
  async loadCarrierRequest(calamityId) {
    await authentication.isAuthenticated();
    const response = await axios.get(
      `${this.baseUrl}/GetCarrierRequest?calamityId=${calamityId}`,
      {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      }
    );
    return response.data;
  },
  async sendCalamityCalls(data) {
    await authentication.isAuthenticated();
    const response = await axios.post(
      `${this.baseUrl}/SendCalamityCalls`,
      data,
      {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      }
    );
    return response.data;
  },
  async sendCarrierRequest(data) {
    await authentication.isAuthenticated();
    const response = await axios.post(
      `${this.baseUrl}/SendCarrierRequest`,
      {
        data
      },
      {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      }
    );
    return response.data;
  },
  async getCalamityCallsStatus(data) {
    await authentication.isAuthenticated();
    const response = await axios.post(
      `${this.baseUrl}/GetCalamityCallsStatus`,
      data,
      {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      }
    );
    return response.data;
  },
  async cancelCalamityCalls(data) {
    await authentication.isAuthenticated();
    const response = await axios.post(
      `${this.baseUrl}/CancelCalamityCalls`,
      data,
      {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      }
    );
    return response.data;
  },
  async sendClientEmail(data) {
    await authentication.isAuthenticated();
    const response = await axios.post(
      `${this.baseUrl}/SendClientEmail`,
      {
        data
      },
      {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      }
    );
    return response.data;
  }
};
